export var PrerequisiteTypeEnum;
(function (PrerequisiteTypeEnum) {
    PrerequisiteTypeEnum["ABILITY_SCORE"] = "ability-score";
    PrerequisiteTypeEnum["CUSTOM_VALUE"] = "custom-value";
    PrerequisiteTypeEnum["PROFICIENCY"] = "proficiency";
    PrerequisiteTypeEnum["SPECIES"] = "species";
    PrerequisiteTypeEnum["SIZE"] = "size";
    PrerequisiteTypeEnum["SPECIES_OPTION"] = "species-option";
    PrerequisiteTypeEnum["LEVEL"] = "level";
    PrerequisiteTypeEnum["CLASS"] = "class";
    PrerequisiteTypeEnum["FEAT"] = "feat";
    PrerequisiteTypeEnum["CLASS_FEATURE"] = "class-feature";
})(PrerequisiteTypeEnum || (PrerequisiteTypeEnum = {}));
export var PrerequisiteSubTypeEnum;
(function (PrerequisiteSubTypeEnum) {
    PrerequisiteSubTypeEnum["CHARACTER_LEVEL"] = "character-level";
})(PrerequisiteSubTypeEnum || (PrerequisiteSubTypeEnum = {}));
